import Env from "config/environment";

const { marketingHost } = Env;

const useProofConstants = marketingHost.includes("proof.com");
export const supportHost = useProofConstants
  ? "https://support.proof.com"
  : "https://support.notarize.com";
export const supportEmail = useProofConstants ? "support@proof.com" : "support@notarize.com";
export const supportPhoneNumber = "1-888-483-4330";
export const supportPage = `${supportHost}/hc/en-us`;

export const proofWorkrampRegisterUrl = "https://proofacademy.workramp.io/register";
export const quickStampHelpUrl = `${supportHost}/hc/en-us/articles/4416007636503-How-to-Use-Quick-Stamp-to-Notarize-Documents`;
export const ihnKnowledgeArticlesUrl = `${supportHost}/hc/en-us`;
export const notagigAcademyLink = `${marketingHost}/academy/notary-onboarding-training`;
export const notaryPayoutUrl = `${supportHost}/hc/en-us/articles/360057055154-Notary-Payment-and-Payout`;
export const deviceSelectionHelpUrl = `${supportHost}/hc/en-us/sections/360010760094`;
export const desktopAVPermissionsHelpUrl = `${supportHost}/hc/en-us/articles/4414775422487`;
export const desktopCameraHelpUrl = `${supportHost}/hc/en-us/articles/4413862395927`;
export const mobileAVPermissionsHelpUrl = `${supportHost}/hc/en-us/articles/14237306788503`;
export const kbaFailureUrl = `${supportHost}/hc/en-us/articles/10468298021271`;
export const idFailureUrl = `${supportHost}/hc/en-us/articles/360058801313-Unable-to-Confirm-Identity-Try-this`;
export const firewallTroubleshootingUrl = `${supportHost}/hc/en-us/articles/360058955173-Firewall-Troubleshooting`;
export const documentSupportUrl = `${supportHost}/hc/en-us/articles/360056906514-What-Documents-Can-Be-Notarized-on-the-Notarize-Platform`;
export const ps1583AllowedIdsUrl = `${supportHost}/hc/en-us/articles/360056909474-What-types-of-ID-are-allowed-on-USPS-Form-1583s`;
export const ps1583AllowedSecondaryIdsUrl = `${supportHost}/hc/en-us/articles/360056909474-What-types-of-ID-are-allowed-on-USPS-Form-1583s`;
export const allowedPrimaryIdsUrl = `${supportHost}/hc/en-us/articles/360057120014-What-form-of-ID-is-acceptable-for-online-notarization`;
export const browserSupportUrl = `${supportHost}/hc/en-us/articles/360056907554-Will-my-Computer-Work-for-Remote-Notarization`;
export const txnPrepGuide = `${supportHost}/hc/en-us/articles/8848570520855-Tagging-Documents`;
export const createATemplateUrl = `${supportHost}/hc/en-us/articles/360057075434-Create-a-Template`;
export const templateSupportUrl = `${supportHost}/hc/en-us/articles/9916246439063-Document-Templates`;
export const easyLinkSupportUrl = `${supportHost}/hc/en-us/articles/7980106662807-EasyLink`;
export const referralsSupportUrl = `${supportHost}/hc/en-us/articles/15286351619095`;
export const encompassIntegrationUrl = `${supportHost}/hc/en-us/articles/360062444453-The-Encompass-Integration-for-Lenders`;
export const conditionalDesignationSupportUrl = `${supportHost}/hc/en-us/articles/12467330642967-Conditional-Fields`;
export const mergeDocumentsLearnMoreSupportUrl = `${supportHost}/hc/en-us/articles/20775152987927`;
export const selfServiceSignersGettingStartedUrl = `${supportHost}/hc/en-us/p/self-service`;

export const digitalNotaryCertHelpUrl =
  "https://www.notarize.com/knowledge-center/how-to-acquire-your-digital-certificate-for-notarize";
export const howToDownloadDigitalCertUrl =
  "https://www.notarize.com/knowledge-center/how-to-download-your-digital-certificate";
export const knowledgeAtNotarizeUrl = "https://www.knowledgeatnotarize.com/";
export const privacyRequestUrl = "https://www.proof.com/resources/privacy-request";
